
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/simulator",
      function () {
        return require("private-next-pages/[locale]/simulator.tsx");
      }
    ]);
  